<template>
  <div class="job-summary-main">
    <ReportsHomeV2 :disableFilter="true" :infoSections="[ 'Filter Selection', 'View Option' ]" title="Job Summary Report" :inputDisabled= "true" placeholder="Job Summary"
       @generateReport="generateReport" @shareReport="shareReport" ref="mainReport" :sections="reportSection">
      <div slot="Report Info_Filter Selection">
        <div class="filters-container">
          <Filters title="Shpr Csgn" style="height: 150px" :tableData="shprCsgn" itemKey="ShprCsgn Code" descKey="ShprCsgn Name"
            :selectedObject.sync="shprCsgnFiltered" />
          <Filters title="Customer" style="height: 150px" :tableData="billTo" itemKey="Customer Code" descKey="Customer Name" :selectedObject.sync="customerFiltered"/>
          <Filters title="Job #" style="height: 150px" :tableData="jobnum" itemKey="Job #" :selectedObject.sync="jobnoFiltered"/>
          <Filters title="User ID" style="height: 150px" :tableData="userid" itemKey="UserID" :selectedObject.sync="userNoFiltered"/>
        </div>
        <div class="dates-container">
          <div class="dates-content">
            <div>Job Date</div>
            <div class="border_section">
              <DateTimePicker placeholder="Start" title="Start" :showTime="false" :value.sync="jobdateStart" :maxDate="jobdateEnd"  />
              <DateTimePicker placeholder="End" title="End" :showTime="false" :value.sync="jobdateEnd" :minDate="jobdateStart"  style="margin-left: 15px" />
            </div>
          </div>
          <div class="dates-content" style="margin-left: 5px">
            <div>ETA Date</div>
            <div class="border_section">
              <DateTimePicker placeholder="Start" title="Start" :showTime="false" :value.sync="etadateStart" :maxDate="etadateEnd"/>
              <DateTimePicker placeholder="End" title="End" :showTime="false" :value.sync="etadateEnd" :minDate="etadateStart" style="margin-left: 15px" />
            </div>
          </div>
        </div>
      </div>

      <div slot="Report Info_View Option">
        <div class="inline-row">
          <Dropdown placeholder="Report Type" style="margin-right: 5px" :items="reporttype" itemKey="Report Type" :selectedObject.sync="selectedreporttype" :isRequired="true"
            @selected="reportTypeChange" />
          <Dropdown placeholder="Group By" :items="groupby" itemKey="Group By" :selectedObject.sync="selectedgroupby" :isRequired="true"/>
        </div>

        <div class="inline-row">
          <Dropdown placeholder="Sort By" style="margin-right: 5px" :items="sortby" itemKey="Sort By" :selectedObject.sync="selectedsortby" :isRequired="true" :isDisabled="selectedreporttype && selectedreporttype['Report Type'] == 'Detail'"/>
          <Dropdown placeholder="Ascending" :items="displayview" itemKey="display" :selectedObject.sync="selecteddisplayby" :isRequired="true"/>
        </div>
      </div>

      <div slot="Doc info 2_Filter Selection">
        <div>Yes working!</div>
      </div>
    </ReportsHomeV2>

    <Loader :isVisible.sync="loading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :type="popupType" :show="showPopup" :title="popupTitle" :content="popupContent" @buttonClicked="showPopup = false"></PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';
import Filters from '@/components/Filters.vue';

export default {
  components: {
    ReportsHomeV2, Filters
  },
  data: function() {
    return {
      loading: false,
      loadingText: '',
      // jobno: '',

      selecteddisplayby: null,

      jobdateStart: new Date(new Date().getFullYear(), 0, 1), // first day of current year
      jobdateEnd: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), // last day of current month

      jobdateStartRange: new Date(),
      jobdateEndRange: new Date(),

      etadateStart: new Date(new Date().getFullYear(), 0, 1), // first day of current year
      etadateEnd: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), // last day of current month

      etadateStartRange: new Date(),
      etadateEndRange: new Date(),

      reportSection: [
        {
          name: 'Report Info',
          child: [ 'Filter Selection', 'View Option', ],
          show: true
        },
      ],

      displayview: [
        { display: 'Ascending' , 'Display By': 'ASC'}, 
        { display: 'Descending' , 'Display By': 'DESC'}
      ],

      showPopup: false,
      popupType: 'info',
      popupTitle: '',
      popupContent: '',
      jobData: {},

      jsReportdata: {},
      sumtemplateID: 'rMjWzPq', //summary report
      dettemplateID: 'WBLqWTLxJG', //detail report
      
      shprCsgnFiltered: [],
      customerFiltered: [],
      jobnoFiltered: [],
      userNoFiltered: [],

      reporttype: [],
      groupByList: [],
      groupby: [],
      selectedgroupby: null,
      sortby:  [],
      selectedsortby: null,
      selectedreporttype: null,

      userid:  [],
      billTo:  [],
      shprCsgn:  [],
      jobnum:  [],
    }
  },

  
  props: {
  },
  methods: {
    formatDateTime: function(dateTime, format) {
      if (!dateTime) // if API didn't return a date, dont assign anything
        return; // returning null here would create another field in the data with a null value

      return this.$dateTime.getDateTime(new Date(dateTime), format);
    },

    drillThroughClicked: async function(rptType, series) {
      this.loadText = `Getting details`;
      this.loading = true;
      
      var dataToPost = {
        'rpttype': rptType,
        'series': series,
      }
      
      var ser;
      if(series.includes('/'))
        ser = series.replace('/',' ');

      sessionStorage.setItem(`Drill Through - ${rptType == 'DETAILS_MONTH' ? 'DETAILS_MONTH' : 'TXN_MONTH'} ${series.includes('/') ? ser : series}`, JSON.stringify({ data: dataToPost, series: series }));
      var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Profit & Loss/Drill Through - ${rptType == 'DETAILS_MONTH' ? 'DETAILS_MONTH' : 'TXN_MONTH'} ${series.includes('/') ? ser : series}`);
      window.open(drillThroughLink.href, '_blank');

      this.loading = false;
    },

    generateReport: async function() {
      this.loading = true;
      this.loadingText = 'Generating Report';

       if(this.selectedreporttype && this.selectedreporttype['Report Type'] == 'Detail'){
        this.selectedsortby = this.sortby[1];
      }

      // if(this.selectedreporttype && this.selectedreporttype['Report Type'] == 'Summary' && this.selectedgroupby && this.selectedgroupby['Group By'] == 'User Create Job' || this.selectedgroupby['Group By'] == 'User Confirm Job'){
      //   this.selectedgroupby = this.groupby[0];
      //   this.popupType = 'error';
      //   this.showPopup = true;
      //   this.popupTitle = 'Invalid Dropdown Selected';
      //   this.popupContent = 'User Confirm Job and Use Create Job are only applicable for Detail Report';
      // }

      // let shprCsgnString = this.shprCsgnFiltered.map(c => 'abc');
      // let shprCsgnString = this.shprCsgnFiltered.map(c => {
      //   return 'abc';
      // });

      let shprCsgnString = this.shprCsgnFiltered.map(c => c['ShprCsgn Code'] ? c['ShprCsgn Code'].trim() : '').join(','); 
      let customerFiltered = this.customerFiltered.map(c => c['Customer Code'] ? c['Customer Code'].trim() : '').join(',');
      let jobnoFiltered = this.jobnoFiltered.map(c => c['Job #'] ? c['Job #'].trim() : '').join(',');
      let userNoFiltered = this.userNoFiltered.map(c => c['UserID'] ? c['UserID'].trim() : '').join(',');
      
      // let trim = shprCsgnString.length > 20 ? `${shprCsgnString.substring(0, 17)}...` : shprCsgnString;
      // Above line to if else
      // if (c['ShprCsgn Code']) {
      //   result = c['ShprCsgn Code'].trim();
      // } else {
      //   result = '';
      // }

      // console.log(shprCsgnString);
      // console.log(trim);
      // return;
     
      let dataToPost = {
        'system': 'FMS',
        'jobnoarray': this.jobnoFiltered.map(c => c['Job #'] ? c['Job #'].trim() : '').join(','),
        'shprcsgnarray': this.shprCsgnFiltered.map(c => c['ShprCsgn Code'] ? c['ShprCsgn Code'].trim() : '').join(','),
        'billcustarray': this.customerFiltered.map(c => c['Customer Code'] ? c['Customer Code'].trim() : '').join(','),
        'usercreatearray': this.userNoFiltered.map(c => c['UserID'] ? c['UserID'].trim() : '').join(','),
        'userconfirmarray':  this.userNoFiltered.map(c => c['UserID'] ? c['UserID'].trim() : '').join(','),
        'stjobdate': this.$dateTime.getDateTime(this.jobdateStart, 'yyyy-MM-dd'),
        'edjobdate': this.$dateTime.getDateTime(this.jobdateEnd, 'yyyy-MM-dd'),  
        'stetadate': this.$dateTime.getDateTime(this.etadateStart, 'yyyy-MM-dd'),
        'edetadate': this.$dateTime.getDateTime(this.etadateEnd, 'yyyy-MM-dd'),
        'groupby': this.selectedgroupby['Group By'],
        'sortby': this.selectedsortby['Sort By'],
        //'ascdesc': '',
      };

      let reportType = this.selectedreporttype ? this.selectedreporttype['Report Type'] : '';
      let ascDesc = this.selecteddisplayby ? this.selecteddisplayby['Display By'] : '';
      let result = await this.$apiCallV2(`/JobSummaryListing/rptJobSummary?reporttype=${reportType}&ascdesc=${ascDesc}`, dataToPost);

      if (result) {
        let jsReportData = {
          'Job Date From': `${this.$dateTime.getDateTime(this.jobdateStart, 'yyyy-MM-dd')} to ${this.$dateTime.getDateTime(this.jobdateEnd, 'yyyy-MM-dd')}`,
          'ETA Date From': `${this.$dateTime.getDateTime(this.etadateStart, 'yyyy-MM-dd')} to ${this.$dateTime.getDateTime(this.etadateEnd, 'yyyy-MM-dd')}`,
          'Report Type': this.selectedreporttype['Report Type'],
          'Group By': this.selectedgroupby['Group By'],
          'Sort By': this.selectedsortby['Sort By'],
          'Display By' : this.selecteddisplayby['display'],
          'JobSummaryGroup': result['RptJobSummary']['JobSummaryGroup']
        };

        //result
        let reportId = 'rMjWzPq'; // For summary
        if (this.selectedreporttype) {
          reportId = this.selectedreporttype['Report Type'] == 'Summary' ? 'rMjWzPq' : 'WBLqWTLxJG';
        }

        await this.$refs['mainReport'].generateReport(reportId, jsReportData);
      } else {
        this.popupType = 'error';
        this.showPopup = true;
        this.popupTitle = 'No Data';
        this.popupContent = 'No data for the fields selected';
      }

      this.loading = false;
    },
    shareReport: async function() {
      this.loading = true;
      this.loadingText = 'Generating Link';

      var loginDetails = JSON.parse(localStorage.getItem('loginDetails'));
      let fileName = `${loginDetails['ConfigCode']}_${loginDetails['LoginUserID']}_BCL_${this.jobno}_${this.$dateTime.getDateTime(new Date(), 'yyyyMMddHHmm')}`.split('/').join('_');
      await this.$refs['mainReport'].generateShareLink(fileName, loginDetails['ConfigCode']);

      this.loading = false;
    },

    reportTypeChange: function(e) {
      // summary 3 detail 5
      let temp = this.selectedgroupby;
      if (e['Report Type'] == 'Summary') {
        this.groupby = this.groupByList.filter((groupBy) => {
          return groupBy['Group By'] != 'User Create Job' && groupBy['Group By'] != 'User Confirm Job';  //different condition to switch between 2 reports
        });
      } else if (e['Report Type'] == 'Detail') {
        this.selectedsortby = this.sortby.find(s => s['Sort By'] == 'Group');
        this.groupby = this.groupByList;
      }

      this.selectedgroupby = null;
      this.$nextTick(() => {
        if (temp) {
          if (e['Report Type'] == 'Summary' && (temp['Group By'] == 'User Create Job' || temp['Group By'] == 'User Confirm Job')) {
            this.selectedgroupby = this.groupby[0];
          } else {
            this.selectedgroupby = temp;
          }
        } else {
          this.selectedgroupby = this.groupby[0];
        }
      });
    }
  },
  async mounted() {

    var today = new Date();
    this.jobdateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 0, 0, 0);
    this.jobdateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 0, 23, 59);


    var today = new Date();
    this.etadateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 0, 0, 0);
    this.etadateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 0, 23, 59);
    
    let jobNo = this.$route.query['jobno'];
    
    if (jobNo) {
      this.jobno = jobNo;
      console.log(this.jobno);
      this.loadingText = "Getting Booking Details"
      this.loading  = true;

      this.groupByList = await this.$apiCallV2('/JobSummaryListing/GetListMaster?masterfile=RPT_JOBSUMMARY_GROUPBY');
    

      this.reporttype = await this.$apiCallV2( '/JobSummaryListing/GetListMaster?masterfile=RPT_JOBSUMMARY_RPTTYPE');
      

      this.sortby = await this.$apiCallV2('/JobSummaryListing/GetListMaster?masterfile=RPT_JOBSUMMARY_SORTBY');
   

      this.userid = await this.$apiCallV2('/JobSummaryListing/GetListMaster?masterfile=RPT_JOBSUMMARY_USER');
   
      // console.log(getuserid);

      this.jobnum = await this.$apiCallV2( '/JobSummaryListing/GetListMaster?masterfile=RPT_JOBSUMMARY_JOBNO&module=FMS');
      
      console.log(this.jobnum);

      this.billTo = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' });
      

      this.shprCsgn = await this.$apiCallV2( "/JobMilestones/GetListMaster?master=SHPRCSGNNAME");
   

      this.loading = false;

      this.selectedreporttype = this.reporttype.find(r => r['Report Type'] == 'Summary');
      this.reportTypeChange(this.selectedreporttype);
      this.selectedsortby = this.sortby[1];
      this.selecteddisplayby = this.displayview[0];

    }
  },
  watch: {
    jobdateStart: function(val) {
      this.$emit('update:jobdateStart', val);
    },
    jobdateEnd: function(val) {
      this.$emit('update:jobdateEnd', val);
    },
    etadateStart: function(val) {
      this.$emit('update:etadateStart', val);
    },
    etadateEnd: function(val) {
      this.$emit('update:etadateEnd', val);
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.job-summary-main {
  height: 100%;
  width: 100%;
}

.inline-row {
  display: flex;
}

.job-summary-section{
  width: 100%;
  padding-left: 4px;

  > button {
    padding: 0 15px;
    float: right;
  }
  
  > .booking-details-remarks {
    border: 1px solid rgb(200,200,200);
    border-radius: 3px;
    width: 100%;
    height: calc(100% - 21px);
    overflow: auto;
    max-height: 185px;
    display: flex;
    flex-wrap: wrap;
    padding-left: 5px;
    padding-right: 5px;
  
     > button {
       float: right;
       padding: 2px 5px;
     }
  }
}

  > .filter-check {
    position: absolute;
    top: -10px;
    background-color: white;
    padding: 0 10px;
    left: 15px;
  }

  > .dates {
    display: flex;
    position: absolute;
  }

#rcorners2 {
  border: 1px solid rgb(200,200,200);
  border-radius: 3px;
  padding: 5px 0 0 5px; 
  width: 280px;
  height: 150px;  
}

.filters-container, .dates-container {
  display: flex;
  width: 100%;
}

.dates-container {
  margin-top: 5px;

  > .dates-content {
    width: 50%;
    
    > .border_section {
      border: 1px solid rgb(200,200,200);
      border-radius: 3px;
      padding: 5px 0 0 5px;
      width: 100%;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>